import axios from '../assets/axios'

export default {
  namespaced: true,

  state: {
  },

  actions: {
    // 退款页面初始化
    async refundInitX ({ commit }, params) {
      const response = await axios.post('/refund/member/v1/refundInit', params)
      return response.data
    },
    // 申请退款
    async refundApplyX ({ commit }, params) {
      const response = await axios.post('/refund/member/v1/applyRefund', params)
      return response.data
    },
    // 获取用户有效的会员列表（客服页面需要）
    async queryMemberListX ({ commit }, params) {
      const response = await axios.post('/refund/member/v1/effectivityMemberList', params)
      return response.data
    },
    // 退款检查，以及退款方式的返回, （会员主页的申请退款按钮判断）
    async refundCheckX ({ commit }, params) {
      const response = await axios.post('/refund/member/v1/refundCheck', params)
      return response.data
    }
  }
}
